import React, { useCallback, useEffect, useState } from "react";
import BackButton from "../../../components/common/BackButton";
import SingleAppointmentComponent from "./SingleAppointmentComponent";
import noSlotVector from "../../../assets/images/no-slots.svg";

import blueClock from "../../../assets/icons/blue-clock-icon.png";

import { useDispatch, useSelector } from "react-redux";
import { ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { getUrlWithToken } from "../utilityFunctions";
import { logEventWithData } from "../../../app/eventSlice";
import {
  setStateFromPayload,
  navigoShowError,
  getPlanService,
} from "../navigoSlice";
import { SocialSharing } from "@ionic-native/social-sharing";

import NavigoServices from "../../../services/NavigoServices";
import { NoAppointmentFound } from "./noAppointmentFound";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import GeneralNavigoCard from "./generalNavigoCard";
import { IonContent, IonPage, IonSlide, IonSlides, useIonViewWillEnter } from "@ionic/react";
import navigoServicesBanner from "../../../assets/images/navigo-services-banner.png";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import CommonHeader from "../../../CommonHeader";

let navigoServicesSwiper = null;
const navigoServicesSlideOpts = {
  initialSlide: 0,
  speed: 500,

  on: {
    beforeInit() {
      navigoServicesSwiper = this;
    },
  },
};

SwiperCore.use([Pagination]);
export default function NavigoFirstSection({ handleGotoAddress }) {
  const token = useSelector((store) => store.tab.docToken?.token);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const serviceType = queryParams.get("serviceType") || 1;
  const navigoStore = useSelector((store) => store.navigo);
  const user = useSelector((store) => store.login.user);
  const plan = useSelector((state) => state.home.plans);
  const [finalServices, setFinalServices] = useState([]);
  const [noService, setNoService] = useState(false);
  const dispatch = useDispatch();
  const { services, upcomingAppointments, serviceTypeId } = navigoStore.ui;
  const { plans, servicePlan } = navigoStore;
  const [selectedPlan, setSelectedPlan] = useState(plans?.length === 1 ? (plans[0]?.name || "") : "");
  const [planId, setPlanId] = useState(plans?.length === 1 ? (plans[0]?.planId || "") : "");
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const [isPB, setIsPB] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isFirstEnterRef = React.useRef(true);

  useEffect(() => {
    const source = localStorage.getItem("app_source");
    setIsPB(source === "pb");
  }, []);
  const patientProfile = useSelector(
    (store) => store.login.user.patientProfile,
  );
  // const serviceType = useSelector((state) => state.service.serviceType);
  useEffect(() => {
    if (plans?.length === 1 && !planId) {
      setSelectedPlan(plans[0].name);
      setPlanId(plans[0].planId);
    } else if (plans?.length > 1 && !planId) {
      setIsPlanModalOpen(true);
    }
  }, [plans]);
  useEffect(() => {
    const fetchServices = async () => {
      if (!planId) return;
      setIsLoading(true);
      dispatch(
        getPlanService({
          pageNum: 0,
          pageSize: 0,
          patientId: patientProfile.id,
          planId: planId,
          serviceType: Number(serviceType),
          skipValidation: true
        }),
      ).finally(() => setIsLoading(false));
    };
    fetchServices();
  }, [planId]);

  useIonViewWillEnter(() => {
    if (isFirstEnterRef.current) {
      isFirstEnterRef.current = false;
      return;
    }
    if (!planId) return;
    setIsLoading(true);
    dispatch(
      getPlanService({
        pageNum: 0,
        pageSize: 0,
        patientId: patientProfile.id,
        planId: planId,
        serviceType: Number(serviceType),
        skipValidation: true,
      }),
    ).finally(() => setIsLoading(false));
  });
  useEffect(() => {
    if (servicePlan && servicePlan.length > 0) {
      const filteredServices = servicePlan.filter(
        (service) =>
          service?.serviceTypeName === "Consultation" &&
          service?.serviceId !== parseInt(process.env.REACT_APP_HRA_ID) &&
          service?.serviceSubTypeId !== 3,
      );

      setFinalServices(filteredServices.length > 0 ? filteredServices : []);
    } else {
      setFinalServices([]);
    }
  }, [servicePlan, planId]);

  return (
    <IonPage>
      <IonContent>
        {isLoading ? (
          <>
            {isPB && <CommonHeader />}
            <CircularProgress
              className="ion-router-circular-progress"
              style={{ marginTop: "200px" }}
            />
          </>
        ) : (
        <React.Fragment>
          {isPB && <CommonHeader />}
          <div className="navigo-booking-container">
            <div className="navigo-booking-container-back-button">
              {/* <BackButton></BackButton> */}
              <p>{"Book services"}</p>
            </div>
            <div
              className="border px-4 py-3 mx-4 mt-4 rounded cursor-pointer flex justify-between items-center bg-white shadow"
              onClick={() => setIsPlanModalOpen(true)}
            >
              <span className="font-semibold">{selectedPlan ? `Plan: ${selectedPlan}` : "Select a plan"}</span>
              <svg
                className="w-4 h-4 text-gray-600"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.187l3.71-3.956a.75.75 0 111.08 1.04l-4.25 4.533a.75.75 0 01-1.08 0L5.25 8.27a.75.75 0 01-.02-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            {isPlanModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-40 z-100 flex justify-center items-end">
                <div className="w-full bg-white rounded-t-2xl overflow-hidden max-h-[80vh] flex flex-col">
                  <div className="bg-[#E5E8F0] px-4 py-3 flex justify-between items-center border-b">
                    <span className="text-sm font-bold text-[#12194C]">
                      My Active Plans
                    </span>
                    <button
                      onClick={() => setIsPlanModalOpen(false)}
                      className="text-xl font-light text-[#12194C]"
                    >
                      &times;
                    </button>
                  </div>
                  <div className="overflow-y-auto">
                    {plans.map((plan, index) => (
                      <div
                        key={index}
                        className="px-4 py-3 text-[#12194C] border-b cursor-pointer hover:bg-gray-50"
                        onClick={() => {
                          setSelectedPlan(plan.name);
                          setPlanId(plan.planId);
                          setIsPlanModalOpen(false);
                          setIsLoading(true);
                          dispatch(
                            getPlanService({
                              pageNum: 0,
                              pageSize: 0,
                              patientId: patientProfile.id,
                              planId: plan.planId,
                              serviceType: Number(serviceType),
                              skipValidation: true
                            }),
                          ).finally(() => setIsLoading(false));
                        }}
                      >
                        {plan.name}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="navigo-booking-container-section-2">
              {finalServices && finalServices.length > 0 && (
                <div>
                  {finalServices.map((service, index) => {
                    return (
                      <GeneralNavigoCard
                        service={service}
                        handleGotoAddress={handleGotoAddress}
                        planId={planId}
                        pageType={8}
                      />
                    );
                  })}
                </div>
              )}
              {noService && finalServices && finalServices.length === 0 && (
                <div className="navigo-booking-container-section-2-no-service">
                  <img src={noSlotVector} alt="bg-img" />
                  <p>No service found.</p>
                </div>
              )}
            </div>
          </div>
        </React.Fragment>
        )}
      </IonContent>
    </IonPage>
  );
}
